import React, { useState } from "react";
import {
  ActionIcon,
  Badge,
  Button,
  Divider,
  Group,
  Text,
  UnstyledButton,
} from "@mantine/core";
import _ from "lodash";

import DataTable from "./dataTable";
import { useFormRender } from "../hooks/useFormRender";
import ReactJson from "react-json-view";
import { IconCirclePlus } from "@tabler/icons";
import { useTranslation } from "react-i18next";
// const LocalPageList = ({form, fieldName, onFormSubmit, tableSchema, formSchema, ...props}) =>{
const LocalPageList = ({
  rows,
  onFormSubmit,
  tableSchema,
  formSchema = {},
  readOnly = false,
  btnLabel = "Add",
  onActionBtnClick = () => {},
  rowFilter = null,

  ...props
}) => {
  // const rows = _.get(form.values, fieldName)

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const onSubmit = ({ values, formMode }) => {
    if (!formMode) return;

    if (formMode === "add") {
      // console.log("add", values);
      rows.unshift(values);
      // form.setFieldValue(fieldName, [...rows])
    }

    if (formMode === "edit") {
      //   console.log("edit", values._id);
      rows[selectedIndex] = { ...values };
      // form.setFieldValue(fieldName, [...rows])
    }
    formAction.close();
    return onFormSubmit([...rows]);
  };

  const handleOnAdd = () => {
    formAction.open({ mode: "add" });
  };

  const sourceRows = rows ?? [];
  const visibleRows = rowFilter ? sourceRows.filter(rowFilter) : sourceRows;

  const sourceIndexOf = (rowIndex) => {
    if (!rowFilter) return rowIndex;
    return sourceRows.indexOf(visibleRows[rowIndex]);
  };

  const handleOnEdit = ({ data, rowIndex }) => {
    if (readOnly) return;
    // console.log("handleONEdit");
    setSelectedIndex(sourceIndexOf(rowIndex));
    formAction.open({ mode: "edit", data });
  };

  const handleOnRemove = (index) => {
    if (readOnly) return;
    const sourceIndex = sourceIndexOf(index);
    if (sourceIndex < 0) return;
    rows.splice(sourceIndex, 1);
    return onFormSubmit([...rows]);
  };

  const handleActionBtnClick = ({ action, data, rowIndex }) => {
    // console.log(action, data, rowIndex);
    if (action === "delete") return handleOnRemove(rowIndex);
    if (action === "edit") return handleOnEdit({ data, rowIndex });
    if (onActionBtnClick) return onActionBtnClick({ action, data, rowIndex });
  };

  const onSubmitSucess = () => {};

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    onSubmitSucess,
    onSubmit
  );

  const { t } = useTranslation();
  const columns = readOnly
    ? (tableSchema.columns ?? []).filter((column) => !column.isAction)
    : tableSchema.columns;

  return (
    <>
      {/* <ReactJson name="localPageList"  src={rows} style={{background:'white'}} collapsed/> */}
      {/* selectedIndex:{selectedIndex} */}

      {_.isEmpty(sourceRows) ? (
        // <Badge color={"red"}> No Data Yet </Badge>
        <></>
      ) : (
        <DataTable
          data={visibleRows}
          columns={columns}
          hidePagination={true}
          hideSearchBar={true}
          hideColumnHeaders={tableSchema.hideColumnHeaders}
          onRowDoubleClick={readOnly ? null : handleOnEdit}
          onActionBtnClick={readOnly ? undefined : handleActionBtnClick}
          minHeight="0px"
          padding={0}
        />
      )}

      <div>
        {!readOnly && (
          <Button
            size="xs"
            variant="filled"
            leftIcon={<IconCirclePlus size={14} />}
            onClick={handleOnAdd}
            mt="sm"
          >
            {t(btnLabel)}
          </Button>
        )}
      </div>

      {renderForm()}
    </>
  );
};

export default LocalPageList;
